var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppImageMeetingHangup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3394 20.8443C28.0877 19.7027 28.4616 18.8162 28.4421 17.8518C28.0286 16.3363 27.2804 14.9584 26.1576 13.8357C20.1932 7.87129 11.6497 7.87129 5.68467 13.8363C4.56254 14.9584 3.81426 16.3363 3.40084 17.8518C3.55794 19.1121 4.11014 20.1356 4.73913 20.9228L10.2517 19.0329C10.4679 18.5014 10.7041 18.1081 10.8028 17.6941C10.6646 17.0054 10.4283 16.4538 10.0155 15.8047C13.4014 12.8122 18.5396 12.8323 21.9059 15.8833C21.6106 16.3759 21.3744 16.9263 21.1972 17.537C21.2953 18.0685 21.3744 18.4618 21.5912 18.8758L27.3394 20.8443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppImageMeetingHangup);
export default __webpack_public_path__ + "static/media/app_image_meeting_hangup.6f25e56b495e74d33e35c55c942b75bd.svg";
export { ForwardRef as ReactComponent };